import {defineCustomElement} from 'extensions/ui-utils';
import stylesheet from './x-selectable-card.scss?as=stylesheet';
import {html, LitElement} from 'lit';
import {classMap} from 'lit/directives/class-map.js';
import 'extensions/ui-components/x-quantity';

export class SelectableCard extends LitElement {
	static get styles () {
		return [stylesheet];
	}

	static get properties () {
		return {
			selected: {
				type: Boolean
			}

		};
	}

	constructor () {
		super();


		/**
		 * @type {boolean}
		 */
		this.selected = false;
	}


	render () {
		const classes = {
			card: true,
			selected: this.selected
		};

		return html`
			<div class="${classMap(classes)}">
				<div class="flags">
					<div class="selected-indicator"></div>
					<slot name="flag"></slot>
				</div>
				<slot></slot>
			</div>
		`;
	}
};

defineCustomElement('x-selectable-card', SelectableCard);
